import styled, { css } from 'styled-components';

export const ParticipantsListWrapper = styled.div`
  display: flex;
  align-items: center;
  
  ${({ wrapperStyles }) => wrapperStyles && css`
    flex-wrap: wrap;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/notes-simple-list/meeting-notes-list-item/meeting-participants-feedbacks/participants-list/styles.js